import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { collection, addDoc, onSnapshot, query, where, getDocs } from "firebase/firestore";
import { db } from "../Firebase/firebase";
import { UserAuth } from "../Firebase/authcontext";
import "../CSS/FriendDM.css";

function FriendChatModel() {
    const { user } = UserAuth();
    const [text, setText] = useState("");
    const [messages, setMessages] = useState([]);
    const [friendName, setFriendName] = useState("");
    const [friendPhoto, setFriendPhoto] = useState("");
    const { uid } = useParams();
    const messagesEndRef = useRef(null);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (text) {
            const collect = collection(db, "Friends_Chat");
            const now = new Date();
            const formattedTime = {
                day: now.getDate(),
                month: now.getMonth() + 1,
                year: now.getFullYear(),
                hour: now.getHours(),
                minute: now.getMinutes(),
                second: now.getSeconds(),
            };

            await addDoc(collect, {
                message: text,
                timestamp: formattedTime,
                from: user.uid,
                to: uid,
            });
        }
        setText("");
    };

    useEffect(() => {
        const fetchFriendName = async () => {
            const friendQuery = query(collection(db, "User"), where("uid", "==", uid));
            const querySnapshot = await getDocs(friendQuery);
            if (!querySnapshot.empty) {
                const friendDoc = querySnapshot.docs[0];
                setFriendName(friendDoc.data().displayName);
                setFriendPhoto(friendDoc.data().photoURL);
            }
        };

        fetchFriendName();

        const collect = collection(db, "Friends_Chat");
        const q = query(collect);

        // Set up Firestore real-time listener
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const arr = [];
            querySnapshot.forEach((doc) => {
                arr.push(doc.data());
            });

            // Sort the messages based on the timestamp
            arr.sort((a, b) => {
                const dateA = new Date(
                    a.timestamp.year,
                    a.timestamp.month - 1,
                    a.timestamp.day,
                    a.timestamp.hour,
                    a.timestamp.minute
                );
                const dateB = new Date(
                    b.timestamp.year,
                    b.timestamp.month - 1,
                    b.timestamp.day,
                    b.timestamp.hour,
                    b.timestamp.minute
                );
                return dateA - dateB;
            });

            setMessages(arr);
        });

        // Clean up listener on component unmount
        return () => unsubscribe();
    }, [uid]);

    // Automatically scroll to the bottom of messages
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    return (
        <div className="chat-container">
            <div className="messages" id="messages">
            {messages.map((message, index) => (
                <div key={index} className={`message ${message.from === user.uid ? 'outgoing' : 'incoming'}`}>
                    <div className={`message-content ${message.from !== user.uid ? 'incoming' : ''}`}>
                        {message.from !== user.uid && (
                            <img
                                src={friendPhoto}
                                alt="Friend"
                                className="friend-photo"
                            />
                        )}
                        <div>
                            {message.from !== user.uid && (
                                <span className="friend-name">{friendName}</span>
                            )}
                            <p className="message-text">{message.message}</p>
                            <span className="message-time">
                                {`${message.timestamp.day}/${message.timestamp.month}/${message.timestamp.year} ${message.timestamp.hour}:${message.timestamp.minute}`}
                            </span>
                        </div>
                    </div>
                </div>
            ))}
                <div ref={messagesEndRef}></div>
            </div>

            <div className="input-container">
                <input
                    onChange={(e) => setText(e.target.value)}
                    type="text"
                    id="text-input"
                    value={text}
                    placeholder="Type a message..."
                />
                <button onClick={handleSubmit} id="send-button">Send</button>
            </div>
        </div>
    );
}

export default FriendChatModel;
